// extracted by mini-css-extract-plugin
module.exports = {"detail":"detail_detail__FRbYq","pre":"detail_pre__2bPvc"};